const route = {
	path: ':subsidiaryId/:subsidiaryName/accounting-periods/:periodId/records/:id',
	name: 'records-detail',
	meta: {
		title: 'DETALLE',
		noChangeCompany: true,
	},
	component: () => import('@/pages/records/page-record-detail'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/records-detail.js